export const toUniv = {
  "supple": {
    "takaska_8to9": "随時運行"
  },
  "normal": {
    "takasaka": [
      820, 825, 830, 835, 840,
      910, 915, 925, 934, 941, 949, 956,
      1006, 1011, 1019, 1025, 1030, 1034, 1040, 1042, 1045, 1048, 1050, 1055, 1058,
      1104, 1116, 1128, 1135, 1151, 1205, 1221, 1235, 1251, 1255, 1259,
      1305, 1310, 1315, 1320, 1325, 1328, 1335, 1351,
      1405, 1421, 1435, 1451, 1459,
      1505, 1513, 1520, 1528, 1535, 1551,
      1605, 1621, 1634, 1651,
      1720, 1735, 1751,
      1808, 1831
    ],
    "kitasaka": [
      807, 831, 855,
      902, 937,
      1007, 1032, 1058,
      1148,
      1232,
      1301, 1317,
      1417, 1447,
      1539, 1559,
      1649,
      1706
    ],
    "kumagaya": [
      805, 815, 820,
      1000, 1010,
      1230, 1240,
      1430,
      1620
    ],
    "kounosu": [
      820
    ]
  },
  "sat": {
    "takasaka": [
      840,
      903, 915, 925, 940, 953,
      1006, 1021, 1036, 1051,
      1105, 1135, 1151,
      1205, 1235, 1251,
      1305, 1335, 1351,
      1405, 1435, 1451,
      1505, 1535, 1551,
      1636, 1651,
      1721, 1735,
      1805
    ],
    "kitasaka": [
      837,
      1017,
      1147,
      1217,
      1447,
      1514
    ],
    "kumagaya": [
      820,
      1000,
      1230
    ],
    "kounosu": []
  },
  "vacation" : {
    "takasaka":[
      841, 857,
      911, 926, 941, 956,
      1011, 1025, 1036, 1049,
      1105, 1116, 1135, 1151,
      1205, 1235, 1251,
      1305, 1335, 1351,
      1405, 1435, 1451,
      1505, 1535, 1551,
      1605, 1635, 1651,
      1705, 1721, 1751,
      1808
    ],
    "kitasaka":[
      842,
      922,
      1045,
      1112,
      1217,
      1317,
      1417,
      1517,
      1613
    ],
    "kumagaya":[
      820,
      1000,
      1230
    ],
    "kounosu":[]
  }
};

export const fromUniv = {
  "normal": {
    "takasaka": [
      946,
      1007, 1015, 1031, 1045,
      1100, 1116, 1122, 1131, 1146,
      1201, 1216, 1231, 1245, 1247, 1252,
      1300, 1303, 1307, 1310, 1316, 1322, 1331, 1346,
      1401, 1416, 1431, 1446, 1452,
      1503, 1510, 1515, 1525, 1530, 1534, 1540, 1545, 1552,
      1601, 1617, 1639, 1644, 1656,
      1710, 1715, 1720, 1725, 1730, 1740, 1753,
      1807, 1815, 1821, 1837, 1843, 1855,
      1908, 1920, 1926, 1934, 1955,
      2008, 2025, 2038, 2045, 2055,
      2108, 2135
    ],
    "kitasaka": [
      1020,
      1136,
      1220, 1249,
      1305,
      1405, 1435,
      1527, 1547,
      1637, 1654,
      1713, 1727, 1750,
      1825, 1853,
      1913, 1945,
      2031
    ],
    "kumagaya": [
      1150,
      1345,
      1535,
      1720, 1725, 1730,
      1920, 1950,
      2115
    ],
    "kounosu": [
      1837,
      1920
    ]
  },
  "sat": {
    "takasaka": [
      1003, 1016, 1031, 1046,
      1116, 1131, 1146,
      1216, 1231, 1246,
      1316, 1331, 1346,
      1416, 1431, 1446,
      1516, 1531, 1555,
      1611, 1626, 1649,
      1711, 1725, 1755,
      1810, 1825, 1855,
      1910, 1940,
      2010, 2037,
      2107
    ],
    "kitasaka": [
      1005,
      1135,
      1205,
      1305,
      1435,
      1502,
      1656,
      1740,
      1840
    ],
    "kumagaya": [
      1145,
      1535,
      1700,
      1900
    ],
    "kounosu": []
  },
  "vacation" : {
    "takasaka":[
      946,
      1015,1022,1031,1046,
      1101,1116,1131,1146,
      1216,1231,1246,
      1316,1331,1346,
      1416,1431,1446,
      1516,1534,1545,
      1609,1631,1644,1655,
      1708,1726,1740,1753,
      1807,1826,1837,1855,
      1908,1926,1939,1955,
      2008,2025,2038,
      2108
    ],
    "kitasaka":[
      1033,
      1100,
      1205,
      1305,
      1405,
      1505,
      1601,
      1738
    ],
    "kumagaya":[
      1145,
      1520,
      1700,
      1900
    ],
    "kounosu":[]
  }
};